export default "__VITE_ASSET__C48yKjrQ__"